module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10257.302428a4.jpg";